import React, { useState } from 'react';
import { Card, Button, Form } from 'react-bootstrap';
import axios from 'axios';

const OrganizationForm = ({ onOrgCreated }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/api/organizations', formData);
      alert('Organization created successfully');
      setFormData({ name: '', description: '' });
      if (onOrgCreated) onOrgCreated();
    } catch (err) {
      alert(err.response?.data?.msg || 'Error creating organization');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mb-4 shadow-sm border-0">
      <Card.Body>
        <Card.Title className="h5 mb-3 text-muted small text-uppercase font-weight-bold">Create New Organization</Card.Title>
        <Form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Label className="small font-weight-bold">Org Name</Form.Label>
            <Form.Control 
              type="text" 
              name="name" 
              value={formData.name} 
              onChange={onChange} 
              size="sm"
              required 
              placeholder="e.g. Real Estate Group"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="small font-weight-bold">Description</Form.Label>
            <Form.Control 
              as="textarea" 
              name="description" 
              value={formData.description} 
              onChange={onChange} 
              size="sm"
              rows={2}
            />
          </Form.Group>
          <Button type="submit" variant="primary" size="sm" block disabled={loading}>
            {loading ? 'Creating...' : 'Create Organization'}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default OrganizationForm;
